import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Form from "../views/Form.vue";
import Hire from "../views/Hire.vue";
import Channel from "../views/Channel.vue"

Vue.use(VueRouter);

const routes = [
    {
        path: "/Home",
        name: "Home",
        component: Home
    },
    {
        path: "/Form",
        name: "Form",
        component: Form
    },
    {
        path: "/hire/:plan",
        name: "hire",
        component: Hire
    },
    {
        path: "/Channel",
        name: "Channel",
        component: Channel
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

export default router;
